module.exports = __webpack_public_path__ + "img/3.53fff6de.jpg";